import React from "react";
import { Trans } from "react-i18next";

import { useTranslation } from "lib/i18n/use-translation";

import {
  AuthLayout,
  Heading,
  Subtitle,
} from "apps/user/common/components/auth-layout";

const InvalidLink: React.FC = () => {
  const { t } = useTranslation(["auth", "common"]);
  return (
    <AuthLayout variant="form">
      <Heading>{t("common:error.generic.title")}</Heading>
      <Subtitle>
        <Trans
          i18nKey="auth:magicLink.invalidBody"
          components={{
            email: (
              <a rel="noreferrer" href="mailto:support@walkingonearth.com">
                support@walkingonearth.com
              </a>
            ),
          }}
        />
      </Subtitle>
    </AuthLayout>
  );
};

export default InvalidLink;
